import { Card, Division, Flex, Heading, Paragraph, Spin } from "@ir/ui";
import { useMasterDataProductPrices } from "@src/presentation/providers/MasterDataProductPricesDataProvider";
import { MASTER_DATA_SEARCH_BY_FIELDS } from "../utils/masterDataSearchBy.config";
import { MasterDataSearchInput } from "../utils/MasterDataSearchInput";
import { MasterDataProductPricesTable } from "../utils/MasterDataProductPricesTable";

export const MasterDataProductPricesPage = () => {
  const { productPrices, loading, search, setSearch, total, setPage } =
    useMasterDataProductPrices();

  let subtitle = "Loading...";
  if (!loading) {
    if (total === 1) {
      subtitle = "1 record";
    } else {
      subtitle = `${total} records`;
    }
  }

  return (
    <Card
      className="master-data-list-page bg-white"
      variant="outlined"
      shadow
      padding="small"
    >
      <Flex
        align="center"
        justifyContent="space-between"
        gap={0.75}
        className="master-data-list-page__header mb-3"
      >
        <Flex direction="column" gap={0.15}>
          <Heading level={6} className="text-grey-700 font-bold m-0">
            Product Prices
          </Heading>
          <Paragraph className="text-grey-500 m-0">{subtitle}</Paragraph>
        </Flex>
        <MasterDataSearchInput
          placeholder="Search product prices"
          searchQuery={search}
          onSearch={setSearch}
          onClear={() => setSearch("")}
          minLength={1}
          fields={MASTER_DATA_SEARCH_BY_FIELDS["product-prices"]}
        />
      </Flex>

      <Division className="master-data-list-page__body">
        {loading ? (
          <Flex align="center" justifyContent="center" className="py-6">
            <Spin tip="Loading..." spinning />
          </Flex>
        ) : (
          <MasterDataProductPricesTable
            productPrices={productPrices}
            search={search}
            setSearch={setSearch}
            setPage={setPage}
          />
        )}
      </Division>
    </Card>
  );
};
